import React, { forwardRef, useCallback } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import cn from '@/lib/clsxm';

type CaptchaProps = {
  id?: string;
  className?: string;
  onChange: (field: string, value: string | null) => void;
  onError?: () => void;
  theme?: 'light' | 'dark';
  size?: 'compact' | 'normal';
};

const Captcha = forwardRef<ReCAPTCHA, CaptchaProps>(
  ({ onChange, className, onError, theme = 'light', size = 'normal', ...props }, ref) => {
    const handleError = useCallback(() => {
      onError?.();
    }, [onError]);

    const handleExpired = useCallback(() => {
      onChange('recaptcha', null);
    }, [onChange]);

    const handleChange = useCallback(
      (val: string | null) => {
        onChange('recaptcha', val);
      },
      [onChange],
    );

    return (
      <div className={cn('mt-4', className)}>
        <ReCAPTCHA
          {...props}
          ref={ref}
          onErrored={handleError}
          onExpired={handleExpired}
          size={size}
          theme={theme}
          hl='fa'
          sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
          onChange={handleChange}
        />
      </div>
    );
  },
);

Captcha.displayName = 'Captcha';

export default Captcha;
